import {IconButton} from '@yandex-delivery/blocks'
import {LeftArrowIcon} from '@yandex-delivery/blocks/icons'

import {classes} from './ServiceCloseButton.classes'

export function ServiceCloseButton() {
  function handleClosePress() {
    // Кнопка отображается в вебвью для проекта Sell&Buy, вебвью мутирует window, см. https://nda.ya.ru/t/H8o4k4li79xnSK
    window.taxi?.app?.requestHideWebView?.()
  }

  return (
    <IconButton
      className={classes.button}
      data-theme-invert
      onPress={handleClosePress}
      shape="circle"
      variant="floating"
    >
      <LeftArrowIcon />
    </IconButton>
  )
}
